import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "./motion";
import { IMAGES, VOLUNTEER } from "../../lib/siteData";

export const VolunteerApp = () => {
  return (
    <section id="volunteer-app" data-testid="volunteer-section" className="relative overflow-hidden bg-ink-surface py-28 md:py-40 border-y border-white/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 md:gap-20">
          <Reveal>
            <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">{VOLUNTEER.overline}</span>
            <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tighter">
              {VOLUNTEER.title}
            </h2>
            <p className="mt-6 max-w-xl font-body text-lg font-light leading-relaxed text-neutral-400">
              {VOLUNTEER.body}
            </p>
            <ul className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {VOLUNTEER.points.map((p) => (
                <li key={p} className="flex items-start gap-3 font-body text-neutral-200">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand/15 text-brand">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
            <a
              href={VOLUNTEER.cta.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="volunteer-app-cta"
              className="group mt-10 inline-flex items-center gap-3 rounded-full bg-white px-7 py-4 font-body text-sm font-semibold uppercase tracking-wide text-ink transition-colors duration-300 hover:bg-brand hover:text-ink"
            >
              {VOLUNTEER.cta.label}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>

          <Reveal delay={0.15} y={60}>
            <div className="group relative aspect-[3/4] overflow-hidden rounded-3xl border border-white/10">
              <img
                src={IMAGES.app}
                alt="Grassroots coach supporting young players at training"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/10 to-transparent" />
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.6 }}
                className="absolute bottom-6 left-6 right-6 rounded-2xl border border-white/15 bg-black/50 p-5 backdrop-blur-md"
              >
                <div className="font-heading text-lg font-medium uppercase tracking-tight text-white">app.sportmate.ai</div>
                <div className="mt-1 font-body text-sm text-neutral-300">Practical support for mini & junior volunteers.</div>
              </motion.div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
